import React from "react"
import styled from "styled-components"
import Header from "./header"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import Typical from 'react-typical';
import Resume from "../components/resume";
import Character from "../images/dec/character.svg";
import Mouse from "../images/dec/mouse.svg";

const StyledHero = styled.section`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  .hero {
    &__container {
      justify-content: flex-start;
      position: relative;
      width: 100%;
      margin-top: 100px;
    }

    &__desc {
      width: 38%;
      margin: 50px 0;
      color: white;
      text-align: justify;
    }
  }

  .container__hero--secondary {
    border-left: 1px solid #212121;
    display: flex;
    justify-content: center;
    margin: 5rem 0;
  }

  .colored {
    text-shadow: 0px 0px 10px black;
  }
`

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  .decoration {
    position: absolute;

    &__mouse {
      left: 30%;
      top: 0;
      width:50%;
      height:30%;
      transition: 0.2s;
      filter: drop-shadow(0px 0px 15px    );
      &:hover {
     
        transition: 0.2s;
        filter: none;
      }
    }
    &__avatar {
      right:1%;
      top: 1;
      height: auto;
      width: 45%;
      overflow: hidden;
      max-height: 100vh;
      transition: 0.2s;
      filter: drop-shadow(0px 0px 15px #00cde2);
      &:hover {
        transform: scale(1.1);
        transition: 0.2s;
        filter: none;
      }
    }
  }
`

export default function Hero() {
  
  return (
    <StyledHero id="home">
      <Header />
      <div className="container hero__container">
        <div className="container__hero--secondary container--secondary">
          <StyledContainer className="container--primary">
          
            
            <p className="colored" data-sal="slide-up" data-sal-easing="ease">
              Hi, I am
            </p>
            <h1 data-sal="slide-up" data-sal-delay="150" data-sal-easing="ease">
              Vishal Dhiman
            </h1>
            <h2
              data-sal="slide-up"
              data-sal-delay="200"
              data-sal-easing="ease"
              className="hero__sub"
            >
              <Typical
              steps={['Software Engineer', 3000,'',1500]}
              loop={Infinity}
              wrapper="p" 
            />
            </h2>
            <p
              data-sal="slide-up"
              data-sal-delay="300"
              data-sal-easing="ease"
              className="hero__desc section__desc"
            >
              Learning, every day....
            </p>
            <div
              data-sal="slide-up"
              data-sal-delay="400"
              data-sal-easing="ease"
            >
              <a
                href="#contact"
                className="btn btn--secondary"
                onClick={e => {
                  e.preventDefault()
                  trackCustomEvent({
                    category: "Get in touch Button",
                    action: "Click",
                    label: "Gatsby Google Analytics Get in touch Button",
                  })
                }}
              >
                Say Hi!
              </a>
              <Resume/>
            </div>
            
          </StyledContainer>
        </div>
        {/* <Board /> */}
      </div>
    </StyledHero>
  )
}
